import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useTheme } from '@mui/material/styles';
import { DeliverySummary } from '../../../../app/services/api/generated';

interface DeliveredInFullProps {
  deliveries: DeliverySummary[];
}

const DeliveredInFull = ({ deliveries }: DeliveredInFullProps) => {
  const theme = useTheme();

  const data = [
    {
      name: 'Delivered In Full',
      value: deliveries.filter(d => d.status === 'DeliveredInFull').length,
    },
    {
      name: 'Not Delivered In Full',
      value: deliveries.filter(d => d.status !== 'DeliveredInFull').length,
    },
  ];

  return (
    <ResponsiveContainer width="100%"
      height={200}>
      <BarChart data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3"
          stroke={theme.palette.divider} />
        <XAxis
          dataKey="name"
          stroke={theme.palette.text.primary}
          style={{ fontSize: theme.typography.textSM.fontSize }}
        />
        <YAxis
          stroke={theme.palette.text.primary}
          style={{ fontSize: theme.typography.textSM.fontSize }}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.textSM.fontSize,
          }}
        />
        <Bar dataKey="value"
          fill={theme.palette.success.main} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default DeliveredInFull;